module.exports = __webpack_public_path__ + "img/multiple-neutral-2.414cdf44.svg";